/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * GRAPHS
 */
const Index = gql`
  mutation PlatformMailer($generalSmtpConfiguration: smtpConfigurationInput) {
    PlatformMailer(generalSmtpConfiguration: $generalSmtpConfiguration) {
      message,
      status
    }
  }
`

/*
 * EXPORTS
 */
export default Index
